import UserAuditList from './UserAuditList/UserAuditList'
import UserList from './UserList/UserList'

export default {
  UserAuditList,
  UserList,
}
